<template>
  <v-card outlined>
    <v-card-text :class="itemAction.scroll ? 'scroll-box': '' ">

      <v-treeview v-if="itemAction.itemvalue"
          v-model="items"
          :items="data"
          selection-type="independent"
          :open.sync="open"
          :filter="filter"
          :search="search"
          open-on-click
          transition
          selectable
          :item-value="(itemAction.value) ? itemAction.value : 'id'">
            <template v-slot:prepend="{ item }">
              <span class="font-weight-bold">{{ itemText(item) }}</span>
            </template>
        </v-treeview>
        <v-treeview v-else
          v-model="items"
          :items="data"
          selection-type="independent"
          :open.sync="open"
          :filter="filter"
          :search="search"
          open-on-click
          transition
          selectable
          return-object>
            <template v-slot:prepend="{ item }">
              <span class="font-weight-bold">{{ itemText(item) }}</span>
            </template>
        </v-treeview>
    </v-card-text>
    <v-card-actions v-if="itemAction.isnoautoload">
      <v-layout justify-end>
        <v-btn class="mr-3" color="success darken-1" @click="sendData" depressed outlined>{{ itemAction.nameBtn }}</v-btn>
      </v-layout>
    </v-card-actions>
  </v-card>

</template>

<script>
import axios from 'axios'
export default {
  name: 'SelectedTreeViewMultipleMain',
  props: ['itemAction', 'onSuccess', 'setterModel'],
  data: () => ({
    active: [],
    open: [1, 2],
    search: null,
    caseSensitive: false,
    data: [],
    items: []
  }),
  created () {
    this.getDinamicData()
  },
  computed: {
    selected () {
      if (!this.active.length) return
      const item = this.active[0]
      return item
    },
    filter () {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined
    }
  },
  methods: {
    itemText (item) {
      if (item && this.itemAction.nameid === 'departamento_id') {
        return `${item.nombre}`
      } else {
        return `${item.nombre}`
      }
    },
    getDinamicData () {
      const token = this.$cookies.get('token')
      axios.get(`${this.itemAction.url}`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
        this.data = []
        this.data.push(...response.data)
        this.seterModel(this.setterModel)
      }).catch(error => {
        if (error == null) {}
      })
    },
    sendData () {
      if (this.items.length <= 0) {
        this.onSuccess({
          id: this.itemAction.nameid,
          data: null,
          nameObject: null,
          objectMain: null,
          fieldMain: this.itemAction
        })
        return
      }

      this.onSuccess({
        id: this.itemAction.nameid,
        data: this.items,
        nameObject: null,
        objectMain: null,
        fieldMain: this.itemAction
      })
    },
    seterModel (val) {
      if (val) this.items = val
    }
  },
  watch: {
    items (val) {
      if (this.itemAction.isnoautoload) return

      if (val.length <= 0) {
        this.onSuccess({
          id: this.itemAction.nameid,
          data: null,
          nameObject: null,
          objectMain: null,
          fieldMain: this.itemAction
        })
        return
      }
      this.onSuccess({
        id: this.itemAction.nameid,
        data: val,
        nameObject: null,
        objectMain: null,
        fieldMain: this.itemAction
      })
    }
  }

}
</script>
<style scoped>
.scroll-box {
  max-height: 250px;
  overflow-x: auto;
}
.scroll-box::-webkit-scrollbar {
  width: 10px;/* width of the entire scrollbar */
}
.scroll-box::-webkit-scrollbar-track {
  background: #d2d2d2;/* color of the tracking area */
  border-radius: 20px;
}
.scroll-box::-webkit-scrollbar-thumb {
  background-color: #3F51B5;  /* color of the scroll thumb */
  border-radius: 20px;       /* roundness of the scroll thumb */
  border: 3px solid #d2d2d2;/* creates padding around scroll thumb */
}
</style>
